module.exports = __webpack_public_path__ + "static/media/Interstate-ExtraLight.bd0f8ba8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/Interstate-ExtraLight.svg
// module id = 594
// module chunks = 0